import { render, staticRenderFns } from "./MedicineAlertAdd.vue?vue&type=template&id=946b9ad6&lang=true&"
import script from "./MedicineAlertAdd.vue?vue&type=script&lang=js&"
export * from "./MedicineAlertAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports